module.exports = __webpack_public_path__ + "static/media/validate-correios-banner-preview.727558a8.svg";